export function normalizeExternalLink(raw: string | null | undefined): string {
  const value = String(raw ?? '').trim().replace(/ /g, '%20');
  if (!value) {
    return '';
  }

  const withProtocol = /^(https?:\/\/)/i.test(value) ? value : `https://${value}`;

  try {
    const url = new URL(withProtocol);
    return url.href.replace(/\/$/, '');
  } catch {
    return value.toLowerCase();
  }
}
